module.exports = __webpack_public_path__ + "img/nav-appointment.c63697c.jpg";